


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { wlPath } from '@/lib/Whitelabel';
import ProductClass from '@/lib/IProductClass';
import StarRating from '@/components/StarRating.vue';

import EmblaCarousel from 'embla-carousel';


// import $ from 'jquery';
// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/carousel';


@Component({
  components: {
    StarRating,
  },
})
export default class ProductCarousel extends Vue {

  // reactive properties
  selectedIndex: number = 0;

  // injected properties
  @Prop({ required: true }) productList!: ProductClass[];

  // non-reactive properties
  private embla: any;
  private timerId: number | undefined = undefined;

  // lifecycle
  mounted() {
    const emblaNode = document.querySelector('.embla');
    const options = {
      loop: true,
      speed: 4,
    };
    this.embla = EmblaCarousel(emblaNode as HTMLElement, options);
    this.embla.on('select', () => {
      this.selectedIndex = this.embla.selectedScrollSnap();
    });
    this.embla.on('dragStart', () => {
      //console.log(`What a drag it is...`);
      this.disposeTimer();
    });
    this.embla.on('dragEnd', () => {
      //console.log(`Kids are different today...`);
      this.createTimer();
    });
    this.createTimer();
  }

  beforeDestroy() {
    this.disposeTimer();
    this.embla.destroy();
    this.embla = null;
  }

  // computed
  get whitelabelPath(): string {
    return wlPath;
  }
  get products(): ProductClass[] {
    return this.productList ? this.productList : [];
  }

  // methods
  createTimer() {
    this.timerId = setInterval(() => {
      if ( this.embla ) {
        this.embla.scrollNext();
        this.embla.scrollNext();
      }
    }, 8000);
  }

  disposeTimer() {
    clearInterval(this.timerId);
    this.timerId = undefined;
  }

  isCenterProduct(index: number) {
    return this.selectedIndex === index;
  }

  btnZoomProduct(productId: number) {
    // todo
  }

}
